export default {
  name: "risA",
  methods: {
    onRisAConfirm() {
      this.$emit("confirm");
    }
  }
};